import type { Map as LeafletMap } from "leaflet";
import { type RefObject, useEffect } from "react";
import type { Fence } from "../types/fence";
import { focusMapOnFence } from "../utils/fence-map-focus";

export function useMapFocusOnSelectedFence(
	selectedFence: Fence | null,
	mapRef: RefObject<LeafletMap | null>
) {
	useEffect(() => {
		if (!(selectedFence && mapRef.current)) {
			return;
		}
		focusMapOnFence(mapRef.current, selectedFence);
	}, [selectedFence, mapRef]);
}
